// Password visibility toggle function
function togglePasswordVisibility(input,eye,closedEye) {
    const passwordInput = document.getElementById(input);
    const eyeIcon = document.getElementById(eye);
    const eyeSlashIcon = document.getElementById(closedEye);

    if (passwordInput.type === 'password') {
        passwordInput.type = 'text';
        eyeIcon.style.display = 'none';
        eyeSlashIcon.style.display = 'block';
    } else {
        passwordInput.type = 'password';
        eyeIcon.style.display = 'block';
        eyeSlashIcon.style.display = 'none';
    }
}